export interface Manhwa {
  id: number;
  title: string;
  author: string;
  genre: string;
  tags: string[];
  status: "连载中" | "已完结";
  lastChapter: string;
  updateInfo: string;
  rating: number;
  views: string;
  cover: string;
  description: string;
  isNew?: boolean;
  isHot?: boolean;
}

export const works: Manhwa[] = [
  {
    id: 1,
    title: "星穹之约",
    author: "鹿岛绘",
    genre: "奇幻冒险",
    tags: ["星际", "魔法", "热血"],
    status: "连载中",
    lastChapter: "第128话",
    updateInfo: "本周三更新",
    rating: 9.5,
    views: "1280万",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20manhwa%20cover%20art%20of%20a%20young%20hero%20holding%20a%20glowing%20starlight%20sword%20under%20a%20cosmic%20constellation%20sky%2C%20epic%20fantasy%20adventure%2C%20vibrant%20anime%20illustration%2C%20clean%20detailed%20line%20art%2C%20dramatic%20cinematic%20lighting%2C%20vertical%20comic%20poster&width=600&height=800&seq=cover-01&orientation=portrait",
    description: "宇宙崩塌之际，少年拾获最后一颗星核，踏上跨越星海的冒险，寻找失落的群星之约。",
    isHot: true,
  },
  {
    id: 2,
    title: "暗夜猎手",
    author: "南城月",
    genre: "热血战斗",
    tags: ["怪物", "变身", "打斗"],
    status: "连载中",
    lastChapter: "第96话",
    updateInfo: "本周五更新",
    rating: 9.3,
    views: "986万",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20of%20a%20cloaked%20hunter%20silhouette%20with%20glowing%20amber%20eyes%20facing%20a%20huge%20monster%20shadow%2C%20dark%20noir%20battle%20scene%2C%20dynamic%20action%20pose%2C%20moody%20lighting%2C%20high%20contrast%20anime%20illustration%2C%20vertical%20comic%20poster&width=600&height=800&seq=cover-02&orientation=portrait",
    description: "当怪物在午夜降临城市，一名沉默的猎人游走于暗影之间，用利刃守住人类最后的黎明。",
    isHot: true,
  },
  {
    id: 3,
    title: "午夜图书馆",
    author: "白昼辞",
    genre: "悬疑惊悚",
    tags: ["怪谈", "推理", "反转"],
    status: "连载中",
    lastChapter: "第47话",
    updateInfo: "本周日更新",
    rating: 9.1,
    views: "642万",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20art%20of%20an%20endless%20dark%20library%20with%20floating%20books%20and%20a%20flickering%20candle%2C%20mysterious%20suspense%20atmosphere%2C%20moonlight%20through%20tall%20windows%2C%20spooky%20eerie%20anime%20illustration%2C%20vertical%20comic%20poster&width=600&height=800&seq=cover-03&orientation=portrait",
    description: "只在午夜开放的神秘图书馆里，每一本无人借阅的书，都藏着一个等待揭晓的真相与秘密。",
  },
  {
    id: 4,
    title: "樱花校园物语",
    author: "风间音",
    genre: "校园青春",
    tags: ["社团", "治愈", "友情"],
    status: "连载中",
    lastChapter: "第210话",
    updateInfo: "本周二更新",
    rating: 9.2,
    views: "1530万",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20art%20of%20a%20school%20campus%20in%20spring%20with%20falling%20pink%20cherry%20blossoms%20and%20smiling%20students%20in%20uniforms%2C%20warm%20youthful%20slice%20of%20life%2C%20bright%20soft%20colors%2C%20anime%20illustration%2C%20vertical%20comic%20poster&width=600&height=800&seq=cover-04&orientation=portrait",
    description: "转学生少女误打误撞加入了神秘社团，在樱花盛开的校园里，遇见了一群改变她命运的伙伴。",
    isHot: true,
  },
  {
    id: 5,
    title: "异能者档案",
    author: "临渊客",
    genre: "都市异能",
    tags: ["觉醒", "组织", "战斗"],
    status: "已完结",
    lastChapter: "全152话",
    updateInfo: "已完结",
    rating: 9.0,
    views: "2200万",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20of%20a%20young%20person%20with%20glowing%20energy%20hand%20surrounded%20by%20floating%20classified%20file%20documents%2C%20modern%20urban%20superpower%20theme%2C%20electric%20highlight%20accents%2C%20sleek%20anime%20illustration%2C%20vertical%20comic%20poster&width=600&height=800&seq=cover-05&orientation=portrait",
    description: "都市深处潜藏着神秘的异能组织，每一份绝密档案背后，都记录着普通人觉醒后的不平凡人生。",
  },
  {
    id: 6,
    title: "末世幸存者",
    author: "灰烬星",
    genre: "科幻末世",
    tags: ["末日", "生存", "机甲"],
    status: "连载中",
    lastChapter: "第88话",
    updateInfo: "本周六更新",
    rating: 8.9,
    views: "517万",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20art%20of%20a%20lone%20survivor%20in%20a%20mech%20suit%20standing%20before%20a%20ruined%20apocalyptic%20city%20skyline%2C%20scifi%20post%20apocalypse%2C%20cool%20steel%20tones%2C%20epic%20wide%20shot%2C%20anime%20illustration%2C%20vertical%20comic%20poster&width=600&height=800&seq=cover-06&orientation=portrait",
    description: "病毒席卷大地，人类文明崩塌。在荒芜的废墟之中，幸存者们驾驶机甲，为最后一盏不灭的灯火而战。",
  },
  {
    id: 7,
    title: "云端恋人",
    author: "麦芽糖",
    genre: "恋爱日常",
    tags: ["纯爱", "日常", "治愈"],
    status: "连载中",
    lastChapter: "第73话",
    updateInfo: "本周四更新",
    rating: 9.4,
    views: "834万",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20art%20of%20a%20romantic%20couple%20under%20a%20soft%20pastel%20cloud%20sky%20with%20gentle%20sunset%20glow%2C%20sweet%20romance%20slice%20of%20life%2C%20delicate%20warm%20tones%2C%20soft%20anime%20illustration%2C%20vertical%20comic%20poster&width=600&height=800&seq=cover-07&orientation=portrait",
    description: "性格截然相反的两个人因一场意外在网上相识，在现实与云端之间，书写温柔又心动的小日常。",
  },
  {
    id: 8,
    title: "龙族后裔",
    author: "青山客",
    genre: "武侠仙侠",
    tags: ["修仙", "龙族", "神话"],
    status: "连载中",
    lastChapter: "第164话",
    updateInfo: "本周一更新",
    rating: 9.1,
    views: "1100万",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20art%20of%20a%20young%20swordsman%20with%20golden%20dragon%20aura%20ascending%20misty%20mountains%20with%20ancient%20temples%2C%20xianxia%20wuxia%20fantasy%2C%20ink%20and%20gold%20style%2C%20epic%20anime%20illustration%2C%20vertical%20comic%20poster&width=600&height=800&seq=cover-08&orientation=portrait",
    description: "背负龙族血脉的少年踏入仙门，在尔虞我诈的修仙路上，一步步揭开上古神龙消失的惊天真相。",
    isHot: true,
  },
  {
    id: 9,
    title: "时间回廊",
    author: "逆时针",
    genre: "悬疑惊悚",
    tags: ["循环", "时间", "解谜"],
    status: "连载中",
    lastChapter: "第39话",
    updateInfo: "新作 本周六更新",
    rating: 9.0,
    views: "298万",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20art%20of%20a%20person%20trapped%20in%20an%20endless%20spiral%20time%20corridor%20with%20clock%20faces%20and%20repeating%20hallways%2C%20time%20loop%20mystery%2C%20surreal%20mind%20bending%20composition%2C%20cool%20moody%20anime%20illustration%2C%20vertical%20comic%20poster&width=600&height=800&seq=cover-09&orientation=portrait",
    description: "每天醒来，少女都会回到事故发生前的同一刻。在不断循环的时间回廊里，她必须找出唯一的破局之法。",
    isNew: true,
  },
  {
    id: 10,
    title: "美食幽灵社",
    author: "一只栗子",
    genre: "恋爱日常",
    tags: ["美食", "治愈", "灵异"],
    status: "连载中",
    lastChapter: "第21话",
    updateInfo: "新作 本周五更新",
    rating: 8.8,
    views: "156万",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20art%20of%20a%20cozy%20little%20ramen%20shop%20with%20a%20friendly%20ghost%20chef%20and%20steaming%20bowls%20of%20noodles%2C%20whimsical%20food%20and%20gentle%20horror%20blend%2C%20warm%20inviting%20colors%2C%20cute%20anime%20illustration%2C%20vertical%20comic%20poster&width=600&height=800&seq=cover-10&orientation=portrait",
    description: "深夜营业的幽灵面馆里，厨艺高超的幽灵与怕鬼的打工少女相遇，用一碗碗热汤治愈每一个夜归的人。",
    isNew: true,
  },
];

export interface Genre {
  name: string;
  count: number;
  desc: string;
  icon: string;
  accent: string;
}

export const genres: Genre[] = [
  { name: "奇幻冒险", count: 326, desc: "跨越星海与异界，踏上未知的旅途", icon: "ri-compass-3-line", accent: "primary" },
  { name: "热血战斗", count: 281, desc: "拳拳到肉，燃到最后的战斗盛宴", icon: "ri-flashlight-line", accent: "accent" },
  { name: "悬疑惊悚", count: 198, desc: "层层反转，烧脑到最后一话", icon: "ri-spy-line", accent: "secondary" },
  { name: "校园青春", count: 243, desc: "盛夏、樱花与难忘的少年时光", icon: "ri-graduation-cap-line", accent: "accent" },
  { name: "都市异能", count: 176, desc: "觉醒与组织的暗流涌动", icon: "ri-battery-2-charge-line", accent: "primary" },
  { name: "科幻末世", count: 142, desc: "末日废土与机甲交织的世界", icon: "ri-rocket-2-line", accent: "secondary" },
  { name: "恋爱日常", count: 305, desc: "细腻心动，甜甜的治愈日常", icon: "ri-heart-3-line", accent: "primary" },
  { name: "武侠仙侠", count: 159, desc: "御剑九天，问鼎修仙之路", icon: "ri-sword-line", accent: "secondary" },
];

export interface ScheduleItem {
  day: string;
  date: string;
  items: { title: string; chapter: string; time: string; tag: string }[];
}

export const weeklySchedule: ScheduleItem[] = [
  {
    day: "周一",
    date: "Mon",
    items: [
      { title: "龙族后裔", chapter: "第164话", time: "09:30", tag: "武侠仙侠" },
      { title: "契约之约", chapter: "第52话", time: "12:00", tag: "奇幻冒险" },
      { title: "风起长街", chapter: "第31话", time: "18:00", tag: "热血战斗" },
    ],
  },
  {
    day: "周二",
    date: "Tue",
    items: [
      { title: "樱花校园物语", chapter: "第210话", time: "10:00", tag: "校园青春" },
      { title: "红发女巫", chapter: "第77话", time: "15:00", tag: "奇幻冒险" },
      { title: "街角咖啡店", chapter: "第66话", time: "20:00", tag: "恋爱日常" },
    ],
  },
  {
    day: "周三",
    date: "Wed",
    items: [
      { title: "星穹之约", chapter: "第128话", time: "09:00", tag: "奇幻冒险" },
      { title: "代号七号", chapter: "第93话", time: "13:00", tag: "都市异能" },
      { title: "深夜诊所", chapter: "第44话", time: "19:30", tag: "悬疑惊悚" },
    ],
  },
  {
    day: "周四",
    date: "Thu",
    items: [
      { title: "云端恋人", chapter: "第73话", time: "11:00", tag: "恋爱日常" },
      { title: "钢铁之心", chapter: "第58话", time: "16:00", tag: "科幻末世" },
      { title: "青鸟来信", chapter: "第90话", time: "21:00", tag: "校园青春" },
    ],
  },
  {
    day: "周五",
    date: "Fri",
    items: [
      { title: "暗夜猎手", chapter: "第96话", time: "10:30", tag: "热血战斗" },
      { title: "美食幽灵社", chapter: "第21话", time: "14:00", tag: "恋爱日常" },
      { title: "幻境之门", chapter: "第112话", time: "18:30", tag: "奇幻冒险" },
    ],
  },
  {
    day: "周六",
    date: "Sat",
    items: [
      { title: "末世幸存者", chapter: "第88话", time: "09:30", tag: "科幻末世" },
      { title: "时间回廊", chapter: "第39话", time: "12:30", tag: "悬疑惊悚" },
      { title: "剑归山海", chapter: "第71话", time: "20:30", tag: "武侠仙侠" },
    ],
  },
  {
    day: "周日",
    date: "Sun",
    items: [
      { title: "午夜图书馆", chapter: "第47话", time: "10:00", tag: "悬疑惊悚" },
      { title: "龙族后裔", chapter: "第165话", time: "15:30", tag: "武侠仙侠" },
      { title: "夏日来信", chapter: "第38话", time: "19:00", tag: "恋爱日常" },
    ],
  },
];

export interface FaqItem {
  question: string;
  answer: string;
}

export const faqs: FaqItem[] = [
  {
    question: "虚空韩漫网是如何保持最新话进度同步的？",
    answer: "虚空韩漫网会实时抓取并校对热门韩漫的连载状态与章节信息，新作上线后会即时在站内进行标记。站内展示的每部作品进度都会经过人工复核，确保追更信息准确、不过期。",
  },
  {
    question: "追更列表的自动提醒是怎么工作的？",
    answer: "你可以把正在追的作品加入追更列表，当作品更新到最新话时，系统会在列表顶部自动提示本期更新进度。打开虚空韩漫网，就能一眼看到每部作品更新到第几话，再也不用担心错过更新。",
  },
  {
    question: "为什么有的作品显示“已完结”？",
    answer: "当一部连载作品更新完毕、官方宣布大结局后，虚空韩漫网会将其标记为“已完结”，并在章节信息中显示全部话数。完结作品会从追更提醒中移除，但仍可在热门与分类中继续查看。",
  },
  {
    question: "每周更新时间表是固定不变的吗？",
    answer: "大部分作品会按照固定的周更节奏更新，但部分作品可能因官方休刊或临时变动而调整。虚空韩漫网会以实际更新情况为准，及时更新周更表，并在追更列表同步最新进度。",
  },
  {
    question: "如何找到最近新上线的韩漫作品？",
    answer: "在首页“新作上线”板块可以看到最近加入虚空韩漫网并即时标记的新作品，也可以通过分类页按题材浏览。所有新作都会在第一时间进入对应分类并同步连载进度。",
  },
];

export interface Testimonial {
  name: string;
  role: string;
  content: string;
  avatar: string;
}

export const testimonials: Testimonial[] = [
  {
    name: "阿禾",
    role: "追更三年 · 奇幻爱好者",
    content: "自从用了虚空韩漫网，追更列表一目了然。每天打开就知道哪部更新了，最新话进度永远对得上，终于告别了满世界翻更新的日子。",
    avatar: "https://readdy.ai/api/search-image?query=flat%20minimal%20avatar%20illustration%20of%20a%20friendly%20young%20woman%20with%20short%20hair%20and%20warm%20smile%2C%20warm%20orange%20and%20cream%20color%20palette%2C%20clean%20vector%20style&width=120&height=120&seq=avatar-01&orientation=squarish",
  },
  {
    name: "老白",
    role: "热血战斗铁粉",
    content: "周更表特别实用，周一更新龙族、周五暗夜猎手我都记在脑子里了。连载进度实时标记，新作一上线立刻通知，追更体验一级棒。",
    avatar: "https://readdy.ai/api/search-image?query=flat%20minimal%20avatar%20illustration%20of%20a%20young%20man%20with%20glasses%20and%20confident%20look%2C%20warm%20orange%20and%20cream%20color%20palette%2C%20clean%20vector%20style&width=120&height=120&seq=avatar-02&orientation=squarish",
  },
  {
    name: "栗子",
    role: "恋爱日常爱好者",
    content: "界面干净不花哨，追更列表更新得又快又准。从云端恋人追到美食幽灵社，每一话进度都清清楚楚，已经安利给身边一群朋友了。",
    avatar: "https://readdy.ai/api/search-image?query=flat%20minimal%20avatar%20illustration%20of%20a%20cute%20young%20woman%20with%20long%20braided%20hair%20and%20gentle%20smile%2C%20warm%20orange%20and%20cream%20color%20palette%2C%20clean%20vector%20style&width=120&height=120&seq=avatar-03&orientation=squarish",
  },
];

export const stats = [
  { value: "1200+", label: "同步连载作品" },
  { value: "8600+", label: "每日更新章节" },
  { value: "320万", label: "活跃追更读者" },
  { value: "99.2%", label: "进度同步准确率" },
];